import { useNavigate, useSearchParams } from "react-router-dom";

import Button from "../../ButtonComponent";
import HeaderModule from "../../ModuleHeaderComponent";
import { useSaveInclusiveContent } from "../mutation"

import { BUTTON_VARIANTS } from "../../constant";

import styles from "./styles.module.scss";
import { CHAPTER_COMPLETE_PERCENTAGE } from "../../../../../utils/cookiesmanager";

const InclusiveEducation = (props) => {
  const { inclusiveEducationContent, isLoading , handleBackClick } = props;

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const courseId = searchParams.get("courseId");
  const moduleId = searchParams.get("moduleId");
  const courseName = searchParams.get("courseName");
  const chapterId = searchParams.get("chapterId");
  const chapterPercentage = localStorage.getItem(CHAPTER_COMPLETE_PERCENTAGE)

  if (isLoading) {
    <div>Loading...</div>;
  }

  const { data: inclusiveEducationContentData } =
    inclusiveEducationContent || {};

  const { response } = inclusiveEducationContentData || {};

  const textData = response?.texts?.[0];

  const videoData = response?.videos?.[0];

  const videoStatus = videoData?.videoStatus;

  const { mutate: saveProgress , isPending } = useSaveInclusiveContent();

  const totalParts = response?.totalContent;

  const handleclick = () => {
    if(videoStatus === 1 && chapterPercentage === '100%'){
      navigate(`/user/chapter-list?${searchParams.toString()}`)
      return;
    }

    saveProgress(
      {
        courseId,
        moduleId,
        chapterId,
        totalParts: totalParts || 1,
        part: 2,
      },
      {
        onSuccess: () => {
          navigate(
            `/user/post-chapter-assessment?courseId=${courseId}&moduleId=${moduleId}&chapterId=${chapterId}&courseName=${courseName}`,
          );
        },
        onError: (error) => {
          console.error("Progress update failed", error);
        },
      },
    );
  };


  return (
    <>
      <HeaderModule
        title={textData?.title}
        className={styles["header-title"]}
        onBackClick={handleBackClick}
      />

      <div className={styles["container-top"]}>
        <div className={styles["content-wrapper"]}>
          <div
            className={styles["title-text"]}
            dangerouslySetInnerHTML={{ __html: textData?.text || "" }}
          />
        </div>
      </div>

      <div className={styles["bottom-wrapper"]}>
        <Button
          label={(videoStatus === 1 && chapterPercentage === '100%') ? 'Back To chapter' :"Start Assessment"}
          buttonVariant={BUTTON_VARIANTS.PRIMARY}
          className={styles["button-class"]}
          onClick={handleclick}
          disabled={isPending}
        />
      </div>
    </>
  );
};

export default InclusiveEducation;
